// Greek-style number formatting: dot thousands separator, comma decimal.
// e.g. 1234.5 -> "1.234,50"
const nf = new Intl.NumberFormat("el-GR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Formatted number, 2 decimals (e.g. "1.234,50"). */
export const num = (v) => nf.format(Number(v) || 0);

/** Formatted amount with euro sign (e.g. "1.234,50€"). */
export const eur = (v) => `${num(v)}€`;

/** Today's local date as an ISO yyyy-mm-dd string (for <input type="date">). */
export const todayISO = () => {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};
